export const LAPTOP_BREAKPOINT = 960;
export const TABLET_BREAKPOINT = 767;

export const MOBILE_ACTIVE_KEYBOARD_HEIGHT = 500;

export const Z_INDEX_EXAMPLE_BOOK_PANEL = 2;
export const Z_INDEX_BANNER = 4;

export const BORDER_RADIUS = 16;
